import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { RestUserService } from '../../services/user/api-rest/rest-user.service';
import { AuthStateService } from '../../services/user/auth-state/auth-state.service';

export const appInitGuard: CanActivateFn = async () => {
  const router          = inject(Router);
  const restUserService = inject(RestUserService);
  const authState       = inject(AuthStateService);

  const raw = localStorage.getItem('userInfo');

  if (!raw) {
    router.navigate(['/login']);
    return false;
  }

  let user: any;
  try {
    user = JSON.parse(raw);
  } catch {
    restUserService.clearSession()
    router.navigate(['/login']);
    return false;
  }

  if (!user?.isAuthenticated) {
    restUserService.clearSession()
    return false;
  }

  try {
    await firstValueFrom(restUserService.getCsrf());
  } catch {
    console.error("csrf not valid")
  }
  try {
    const [auth, permissions] = await Promise.all([
      firstValueFrom(restUserService.validateAuth()),
      firstValueFrom(restUserService.getPermissions()),
    ]);

    authState.setAuth(auth);
    authState.setPermissions(permissions);

    
    redirectByPlatform(router, auth.platform, permissions);
    return false; 

  } catch (error: any) {
    if (error?.status === 0) {
      
      console.warn('[AppInit] Server unreachable — keeping session');
      return true;
    }

    
    console.warn('[AppInit] Session expired — clearing and redirecting to login');
    restUserService.clearSession()
    router.navigate(['/login']);
    return false;
  }
};
function redirectByPlatform(
  router: Router,
  platform: number,
  authorities: string[],
): void {
  switch (platform) {
    case 0:
      router.navigate(['platformdashboard/dasha']);
      break;
    case 1:
      router.navigate(['platformdashboard/dashb']);
      break;
    case 2:
      if (
        authorities.includes('GUEST_REQUEST') &&
        authorities.includes('VIEWREQ')
      ) {
        router.navigate(['corpo/listreq']);
      } else if (
        authorities.includes('GUEST_DEAL') &&
        authorities.includes('VIEWDEL')
      ) {
        router.navigate(['deal/listDeal']);
      } else {
        router.navigate(['platformdashboard/dashc']);
      }
      break;
    default:
      router.navigate(['dashboard']);
  }
}
